import { maxBy, minBy } from 'lodash'

import { BorderSelection, SelectedBorder } from 'common/Prose/utils/table/BorderSelection'

type Border = {
  border: SelectedBorder
  type: 'horizontal' | 'vertical'
}

export const determineDelimitingBorders = (
  selection: BorderSelection,
): { left: Border | undefined; right?: Border | undefined; top?: Border | undefined } => {
  const minTopHorizontalBorder = minBy(selection.horizontals, 'rowOrColIdx')
  const minTopVerticalBorder =
    minBy(selection.verticals, 'fragmentIdx') || selection.verticals.find(({ fragmentIdx }) => !fragmentIdx)

  let top: Border | undefined = undefined
  if (minTopHorizontalBorder && minTopVerticalBorder) {
    if (minTopHorizontalBorder.rowOrColIdx <= (minTopVerticalBorder.fragmentIdx || 0))
      top = { border: minTopHorizontalBorder, type: 'horizontal' }
    else top = { border: minTopVerticalBorder, type: 'vertical' }
  } else if (minTopHorizontalBorder) {
    top = { border: minTopHorizontalBorder, type: 'horizontal' }
  } else if (minTopVerticalBorder) {
    top = { border: minTopVerticalBorder, type: 'vertical' }
  }

  const minLeftHorizontalBorder =
    minBy(selection.horizontals, 'fragmentIdx') || selection.horizontals.find(({ fragmentIdx }) => !fragmentIdx)
  const minLeftVerticalBorder = minBy(selection.verticals, 'rowOrColIdx')
  let left: Border | undefined = undefined
  if (minLeftHorizontalBorder && minLeftVerticalBorder) {
    if ((minLeftHorizontalBorder.fragmentIdx || 0) <= minLeftVerticalBorder.rowOrColIdx)
      left = { border: minLeftHorizontalBorder, type: 'horizontal' }
    else left = { border: minLeftVerticalBorder, type: 'vertical' }
  } else if (minLeftHorizontalBorder) {
    left = { border: minLeftHorizontalBorder, type: 'horizontal' }
  } else if (minLeftVerticalBorder) {
    left = { border: minLeftVerticalBorder, type: 'vertical' }
  }

  const maxRightHorizontalBorder =
    maxBy(selection.horizontals, 'fragmentIdx') || selection.horizontals.find(({ fragmentIdx }) => !fragmentIdx)
  const maxRightVerticalBorder = maxBy(selection.verticals, 'rowOrColIdx')
  let right: Border | undefined = undefined
  if (maxRightHorizontalBorder && maxRightVerticalBorder) {
    if ((maxRightHorizontalBorder.fragmentIdx || 0) >= maxRightVerticalBorder.rowOrColIdx)
      right = { border: maxRightHorizontalBorder, type: 'horizontal' }
    else right = { border: maxRightVerticalBorder, type: 'vertical' }
  } else if (maxRightHorizontalBorder) {
    right = { border: maxRightHorizontalBorder, type: 'horizontal' }
  } else if (maxRightVerticalBorder) {
    right = { border: maxRightVerticalBorder, type: 'vertical' }
  }

  return { left, top, right }
}
